import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';
import Sidebar from './sidebar';
import ScrollAnimation from 'react-animate-on-scroll';

class NETCourses extends Component {

    render() {

        let publicUrl = process.env.PUBLIC_URL+'/'

    return  <div className="course-single-area pd-top-120 pd-bottom-110">
		  <div className="container">
		    <div className="row">
		      <div className="col-lg-8 ">
		        <div className="event-detaila-inner">
		          {/* <div className="thumb mb-4">
		            <img src={publicUrl+"assets/img/other/5.png"} alt="img" />
		          </div> */}
				  <ScrollAnimation animateIn="fadeInRight">
				  
				  <p>The National Educational Testing Bureau of University Grants Commission (UGC) conducts the National Eligibility Test (NET) to determine eligibility for lectureship and for the award of Junior Research Fellowship (JRF) for Indian nationals to ensure minimum standards for the entrants in the teaching profession and research. 
                    </p><br/>
                    <p>The tests are conducted twice a year generally in June and December.  </p>
                    <p>For candidates who desire to pursue research, the <b>Junior Research Fellowship (JRF)</b> is available for five years subject to fulfillment of certain conditions. </p>
                    </ScrollAnimation>	

					<ScrollAnimation animateIn="fadeInRight"><br/>
						<h5 className="mb-0 mt-2">WHY MIET?</h5><br/>
						<p>Whether preparing for a sciences or arts examination, MIET's years of experience and instructors' knowledge help students do well. MIET has been training and coaching students to land their dream education for years. We also have specialized, focused batches to help aspiring lecturers and professors prepare for the UGC-NET examination. 
						</p><br/>
						<p>To suit your comfort and needs, MIET offers different modes and timings of batches so that students can learn and grow at their pace.  </p>
                    </ScrollAnimation>	
                    <ScrollAnimation animateIn="fadeInRight">
                        <div className='blog-details-page-content'>
                            <blockquote>
                            <p><b>Mode of Classes </b>: Online, Offline & Hybrid</p>
                            <p><b>Classes </b>: Evening & Weekend Batches</p>
                            </blockquote>
                        </div>
					</ScrollAnimation>

                    <ScrollAnimation animateIn="fadeInRight">
						<h5 className="mb-0 mt-2">Subjects</h5><br/>
						
						<ul>
                            <li>Humanities (including languages)</li>
                            <li>Social Science</li>
                            <li>Forensic Science</li>
                            <li>Environmental Science</li>
                            <li>Computer Science and Applications	</li>
                            <li>Electronic Science</li>
                        </ul>
                    </ScrollAnimation>
               
                  <ScrollAnimation animateIn="fadeInRight">
					<div className='blog-details-page-content'>
						<blockquote>
						<h5 className="mb-0 mt-2">Exam Pattern:</h5><br/>
                        
                        <table>
							<tr>
								<th>UGC NET Paper</th>
								<th>No. of Questions</th>
								<th>Maximum Marks</th>
								<th>Duration</th>
							</tr>
							<tr>
								<td>Paper 1</td>
								<td>50</td>
								<td>100</td>
								<td>Cumulative time duration of 3 hours.<br/>
                                    Shift 1: 9.30 AM – 12.30 PM<br/>
                                    Shift 2: 2.30 PM – 5.30 PM
                                    </td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							<tr>
								<td>Paper 2</td>
								<td>100</td>
								<td>200</td>
								<td>Cumulative time duration of 3 hours.<br/>
                                Shift 1: 9.30 AM – 12.30 PM<br/>
                                Shift 2: 2.30 PM – 5.30 PM
                                </td>
							</tr>
							<tr>
								<td>Total</td>
								<td>150 MCQs</td>
								<td>300 Marks</td>
								<td>180 minutes</td>
							</tr>
						</table><br/>
						</blockquote>
					</div>
					</ScrollAnimation>
                    <h5 className="mb-0 mt-2">UGC NET Syllabus for Paper 1</h5>
                    <p>All the candidates who have applied for the UGC NET exam, Paper 1 is compulsory for every applicant. The UGC NET Paper 1 has a total of 10 sections. Here are the number of questions and allocated marks for each section of UGC NET Paper 1: </p><br/>
                    <table>
							<tr>
								<th>UGC NET Paper 1 Sections</th>
								<th>Questions in UGC NET Paper 1</th>
								<th>Marks</th>
							</tr>
							<tr>
								<td>Teaching Aptitude</td>
								<td>5</td>
								<td>10</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							<tr>
								<td>Research Aptitude</td>
								<td>5</td>
								<td>10</td>
							</tr>
							<tr>
								<td>Reading Comprehension</td>
								<td>5</td>
								<td>10</td>
							</tr>
                            <tr>
								<td>Communication</td>
								<td>5</td>
								<td>10</td>
							</tr>
                            <tr>
								<td>Reasoning (including Maths)</td>
								<td>5</td>
								<td>10</td>
							</tr>
                            <tr>
								<td>Logical Reasoning</td>
								<td>5</td>
								<td>10</td>
							</tr>
                            <tr>
								<td>Data Interpretation</td>
								<td>5</td>
								<td>10</td>
							</tr>
                            <tr>
								<td>Information & Communication Technology (ICT)</td>
								<td>5</td>
								<td>10</td>
							</tr>
                            <tr>
								<td>People & Environment</td>
								<td>5</td>
								<td>10</td>
							</tr>
                            <tr>
								<td>Higher Education System: Governance, Polity & Administration</td>
								<td>5</td>
								<td>10</td>
							</tr>
                            <tr>
								<td><b>Total</b></td>
								<td><b>50</b></td>
								<td><b>100</b></td>
							</tr>
						</table><br/>
                    <ScrollAnimation animateIn="fadeInRight">
				  
                    <h5 className="mb-0 mt-2">UGC NET Syllabus for Paper 2</h5>
                    <p>The syllabus of UGC NET Paper 2 is based upon the subject, chosen by the aspirants. However, for any subject, people choose, the exam pattern will be the same for all subjects. Here are the details on the UGC NET Paper 2: </p><br/>
                    <table>
							<tr>
								<th>Particulars</th>
								<th>Details</th>
							</tr>
							<tr>
								<td>Number of Subjects</td>
								<td>81 (Candidates need to choose from these)</td>
								{/* <td rowspan="4">120 Minutes </td> */}
							</tr>
							<tr>
								<td>Type of Questions</td>
								<td>Objective MCQs (All questions are compulsory)</td>
							</tr>
							<tr>
								<td>Number of Questions</td>
								<td>100 Questions</td>
							</tr>
                            <tr>
								<td>Mark for each Question</td>
								<td>2 marks</td>
							</tr>
                            <tr>
								<td>Total Marks	</td>
								<td>200 marks</td>
							</tr>
                            <tr>
								<td>Time Duration</td>
								<td>2 hours</td>
							</tr>
						</table><br/>

                    
					
                    </ScrollAnimation>	
					

                  </div>
		      </div>
			  <Sidebar courseRestriction="NET"/>
		    </div>
		  </div>
		</div>

        }
}

export default NETCourses